import React, { useEffect, useMemo, useState } from 'react'
import { useNavbarStore } from 'src/stores/UIStore'
import { Box, styled, IconButton, Button } from '@mui/material';
import InputBoxOnChangePWCheck from './InputBoxOnChangePWCheck';
import InputBoxOnChangeValid from './InputBoxOnChangeValid';
import { putUserPassword } from 'src/api/User';
import { NextButton } from '../common/CommonStyled';
import { Icon_ArrowBack } from '../common/CommonIcons';
import { toast } from 'react-toastify';

interface Props{
    setChangePW : React.Dispatch<boolean>
}

const Header = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', // ✅ camelCase로 수정
    paddingBottom: '32px',
    fontSize:'18px',
    fontWeight:'bold'
  });
const Container = styled(Box)`
    padding: 20px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    gap: 20px;
`;
const FormFieldContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  });
const FormFieldLabel = styled('label')({
    fontWeight: 500,
    fontSize: '14px',
    marginBottom: '10px',
    width: '100%',
    color: 'gray',
  });
const FormInputContainer = styled('div')({
  display: 'flex',
  alignitems: 'center',
  width: '100%',
  gap: '5px',
  minHeight: '46px'
})
const ButtonContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
    width: 100%;
    height: 46px;
    
`;
const CancelButton = styled(Button)`
    font-size: 16px;
  flex: 2;
  background: #F5F5F5;
  color: black;
  margin-right: 10px; /* 버튼 사이에 간격 추가 */

`;

const ChangePassword = ({setChangePW}:Props) => {
    const setField = useNavbarStore((state)=>state.setField)
    const [currentPW,setCurrentPW] = useState('')
    const [newPW,setNewPW] = useState('')
    
    //발리데이션
    const [cond0,setCond0] = useState(false)
    const [cond1,setCond1] = useState(false)
    const [cond2,setCond2] = useState(false)
    const isValid = useMemo(()=>{
        if (!currentPW || !newPW) return false
        return cond0 && cond1 && cond2
    },[cond0,cond1,cond2])

    //네브바 렌더
    useEffect(()=>{ 
        setField('isvisible',false)
        return()=>{
            setField('isvisible',true)
        }
    },[])

    // 보완필요 >> 성공/실패팝업창 없음
    const handleChangePW = async(currentPw:string, newPw:string)=>{
        const response = await putUserPassword(currentPw,newPw)
        if(response === 400){
            toast.error('입력하신 비밀번호와 현재 비밀번호가 다릅니다.',{autoClose:2000})
        }
        else{
            toast.success('비밀번호가 성공적으로 변경되었습니다.',{autoClose:2000})
            setChangePW(false)
        }
    }

  const handleCurrentPW = (e:React.ChangeEvent<HTMLInputElement>)=>{
    setCurrentPW(e.target.value)
  }

  const handleNewPW = (e:React.ChangeEvent<HTMLInputElement>)=>{
    setNewPW(e.target.value)
  }

  return (
    <Container>
        <Header>
            비밀번호 변경
            <IconButton onClick={() => setChangePW(false)} sx={{position:'absolute',left:'10px'}}>
                <Icon_ArrowBack/>
            </IconButton>
        </Header>
        <FormFieldContainer>
            <FormFieldLabel>*기존 비밀번호</FormFieldLabel>
            <FormInputContainer>
            <InputBoxOnChangeValid
                type='password'
                placeholder="기존 비밀번호"
                value={currentPW}
                onChange={handleCurrentPW}
                setCond={setCond0}
                lengthRegex={/^.{8,20}$/}
                lengthSpan='비밀번호 길이는 8~20자만 가능합니다.'
                //eslint-disable-next-line
                regex0={/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?/~\-]).+$/}
                regex0Span='영문, 숫자, 특수문자를 모두 포함해야 합니다.'
            />
            </FormInputContainer>
        </FormFieldContainer>
        <FormFieldContainer>
            <FormFieldLabel>*변경할 비밀번호</FormFieldLabel>
            <FormInputContainer>
            <InputBoxOnChangeValid
                type='password'
                placeholder="비밀번호(8~32자, 영문 대/소문자+숫자+특수문자)"
                value={newPW}
                onChange={handleNewPW}
                setCond={setCond1}
                lengthRegex={/^.{8,20}$/}
                lengthSpan='비밀번호 길이는 8~20자만 가능합니다.'
                //eslint-disable-next-line
                regex0={/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?/~\-]).+$/}
                regex0Span='영문, 숫자, 특수문자를 모두 포함해야 합니다.'
            />
            </FormInputContainer>
        </FormFieldContainer>
        <FormFieldContainer>
            <FormFieldLabel>*변경할 비밀번호 확인</FormFieldLabel>
            <FormInputContainer>
            <InputBoxOnChangePWCheck
                type='password'
                placeholder="변경할 비밀번호 확인"
                value={newPW}
                setCond={setCond2}
            />
            </FormInputContainer>
        </FormFieldContainer>
        <ButtonContainer marginTop='20px'>
            <CancelButton variant="contained" onClick={() => setChangePW(false)}>취소</CancelButton>
            <NextButton disabled={!isValid} onClick={()=>handleChangePW(currentPW,newPW)}>비밀번호 변경</NextButton>
        </ButtonContainer>
    </Container>
  )
}

export default ChangePassword